<section class="filters-dash-container">
  <div class="filter-map">
    <div class="filters">
      <div class="main-filters">
        <mat-button-toggle-group
          class="button-filter-group"
          name="cultureSelection"
          aria-label="Selecionar Cultura"
          [(ngModel)]="selectedCultureId"
          (ngModelChange)="onCulturaChange($event)"
          [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
        >
          @if (isFiltersLoading()) {
            <mat-button-toggle class="button-filter" disabled>
              <mat-spinner
                style="float: left; margin: 10px"
                diameter="20"
                class="button-spinner"
              ></mat-spinner
              >Carregando...
            </mat-button-toggle>
          } @else if (cultures.length === 0) {
            <mat-button-toggle class="button-filter" disabled>
              Nenhuma cultura disponível
            </mat-button-toggle>
          } @else {
            @for (culture of cultures; track culture.id) {
              <mat-button-toggle
                class="button-filter"
                [value]="culture.id"
                [disabled]="!culture.enable"
              >
                {{ culture.description }}
              </mat-button-toggle>
            }
          }
        </mat-button-toggle-group>

        <div class="inputs">
          <div class="form-search">
            <div class="filtro-safras">
              <button
                mat-stroked-button
                disableRipple
                [matMenuTriggerFor]="menuSafra"
                #safraMenuTrigger="matMenuTrigger"
              >
                @if (!safra) {
                  <mat-icon>add</mat-icon>
                }
                @if (!safra) {
                  Selecione a Safra <span style="color: red">*</span>
                } @else {
                  {{ safra }}
                }
              </button>
              <mat-menu
                #menuSafra="matMenu"
                class="filtros-container"
                [overlapTrigger]="false"
                (click)="$event.stopPropagation()"
              >
                <ng-template matMenuContent id="container-filter">
                  <mat-label class="menu-title">Safras</mat-label>
                  <mat-radio-group
                    aria-labelledby="radio-group-label"
                    class="radio-group"
                    [(ngModel)]="safra"
                    (click)="$event.stopPropagation()"
                  >
                    @for (safraOption of safras; track safraOption) {
                      <mat-radio-button
                        class="radio-button"
                        [value]="safraOption"
                        >{{ safraOption }}</mat-radio-button
                      >
                    }
                  </mat-radio-group>
                </ng-template>

                <div (click)="$event.stopPropagation()" class="btn-set">
                  <button
                    mat-button
                    class="clear-btn"
                    (click)="clearSafraFilter()"
                  >
                    Limpar Filtro
                  </button>

                  <button
                    mat-flat-button
                    class="apply-btn"
                    (click)="applySafraFilter()"
                    [disabled]="!safra"
                  >
                    Aplicar
                  </button>
                </div>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <div class="secondary-filters">
        <form [formGroup]="filtrosForm">
          <div class="inputs">
            <mat-form-field
              class="filter-field"
              id="uf-input"
              appearance="outline"
            >
              <mat-label>UF</mat-label>
              <mat-select
                class="input-location"
                formControlName="uf"
                (selectionChange)="onUfChange($event.value)"
              >
                <mat-option value="">Todos</mat-option>
                @for (uf of ufOptions; track uf.value) {
                  <mat-option [value]="uf.value">
                    {{ uf.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field
              class="filter-field"
              id="municipio-input"
              appearance="outline"
            >
              <mat-label>Município</mat-label>
              <input
                type="text"
                matInput
                placeholder="Digite o município"
                formControlName="municipio"
                [matAutocomplete]="autoMunicipio"
              />
              <mat-autocomplete
                #autoMunicipio="matAutocomplete"
                [displayWith]="displayMunicipio"
                (optionSelected)="onMunicipioSelected()"
                autoActiveFirstOption
              >
                <mat-option value="">Todos</mat-option>
                @for (
                  municipio of filteredMunicipios();
                  track municipio.value
                ) {
                  <mat-option [value]="municipio.value">
                    {{ municipio.label }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div class="tertiary-filters">
        <div class="filter filtro-negocios">
          <button
            mat-stroked-button
            disableRipple
            [matMenuTriggerFor]="menuNegocio"
          >
            <mat-icon>add</mat-icon>
            Filtro de negócios
          </button>

          <mat-menu
            #menuNegocio="matMenu"
            class="filtros-container"
            id="filters-input-container"
            [overlapTrigger]="false"
            (click)="$event.stopPropagation()"
          >
            <ng-template matMenuContent>
              <form
                class="filtro-bloco"
                [formGroup]="businessFiltersForm"
                (click)="$event.stopPropagation()"
              >
                @if (userService.isGeoambiente) {
                  <mat-form-field class="filter-field">
                    <mat-label>Cliente</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="client"
                      [matAutocomplete]="autoClient"
                      placeholder="Digite o nome da organização"
                    />
                    <mat-autocomplete
                      #autoClient="matAutocomplete"
                      [displayWith]="displayOrganizationName"
                      autoActiveFirstOption
                    >
                      <mat-option [value]="'__ALL__'">Todos</mat-option>
                      <mat-option [value]="'Geoambiente'"
                        >Geoambiente</mat-option
                      >
                      @for (org of filteredOrganizations; track org.id) {
                        <mat-option [value]="org">{{ org.name }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                }

                <mat-form-field class="filter-field">
                  <mat-label>ID Área</mat-label>
                  <input matInput type="text" formControlName="areaId" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>Produtor</mat-label>
                  <input matInput type="text" formControlName="producer" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>Nome Fazenda</mat-label>
                  <input matInput type="text" formControlName="farmName" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>CAR</mat-label>
                  <input matInput type="text" formControlName="car" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>CPF/CNPJ</mat-label>
                  <input matInput type="text" formControlName="cpfCnpj" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>Contrato</mat-label>
                  <input matInput type="text" formControlName="contract" />
                </mat-form-field>

                <mat-form-field class="filter-field">
                  <mat-label>Apólice</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="insurancePolicy"
                  />
                </mat-form-field>
              </form>

              <div class="btn-set">
                <button
                  mat-button
                  class="clear-btn"
                  (click)="clearBusinessFilters(); $event.stopPropagation()"
                >
                  Limpar Filtros
                </button>
                <button
                  mat-flat-button
                  class="apply-btn"
                  (click)="applyFilters()"
                  [disabled]="!canSearch"
                >
                  Aplicar
                </button>
              </div>
            </ng-template>
          </mat-menu>
        </div>

        <div class="filter filtro-alertas-avisos">
          <button
            mat-stroked-button
            disableRipple
            [matMenuTriggerFor]="menuAlert"
          >
            <mat-icon>filter_alt</mat-icon>
            Filtros de alertas e avisos
          </button>

          <mat-menu
            #menuAlert="matMenu"
            class="filtros-container"
            [overlapTrigger]="false"
            (click)="$event.stopPropagation()"
          >
            <ng-template matMenuContent>
              <div (click)="$event.stopPropagation()" class="checkbox-group">
                <mat-label>Avisos</mat-label>
                @for (aviso of avisos; track aviso.id) {
                  <mat-checkbox
                    [formControl]="aviso.control"
                    class="example-margin"
                  >
                    {{ aviso.label }}
                  </mat-checkbox>
                }
              </div>

              <div (click)="$event.stopPropagation()" class="checkbox-group">
                <mat-label>Alertas</mat-label>
                @for (alerta of alertas; track alerta.id) {
                  <mat-checkbox
                    [formControl]="alerta.control"
                    class="example-margin"
                  >
                    {{ alerta.label }}
                  </mat-checkbox>
                }
              </div>
            </ng-template>

            <div (click)="$event.stopPropagation()" class="btn-set">
              <button
                mat-button
                class="clear-btn"
                (click)="clearAlertsFilters()"
              >
                Limpar Filtros
              </button>
              <button
                mat-flat-button
                class="apply-btn"
                (click)="applyFilters()"
                [disabled]="!canSearch"
              >
                Aplicar
              </button>
            </div>
          </mat-menu>
        </div>

        <!-- Filtro de Zoneamento ZARC -->
        <div class="filter filtro-zarc">
          <button
            mat-stroked-button
            disableRipple
            [matMenuTriggerFor]="menuZarc"
          >
            <mat-icon>filter_alt</mat-icon>
            Filtro de ZARC
          </button>

          <mat-menu
            #menuZarc="matMenu"
            class="filtros-container"
            [overlapTrigger]="false"
            (click)="$event.stopPropagation()"
          >
            <ng-template matMenuContent>
              <div (click)="$event.stopPropagation()" class="checkbox-group">
                <mat-label>Status de Zoneamento ZARC</mat-label>
                @for (filtro of zarcStatusFilters; track filtro.id) {
                  <mat-checkbox
                    [formControl]="filtro.control"
                    class="example-margin"
                  >
                    {{ filtro.label }}
                  </mat-checkbox>
                }
              </div>
            </ng-template>

            <div (click)="$event.stopPropagation()" class="btn-set">
              <button mat-button class="clear-btn" (click)="clearZarcFilters()">
                Limpar Filtros
              </button>
              <button
                mat-flat-button
                class="apply-btn"
                (click)="applyFilters()"
                [disabled]="!canSearch"
              >
                Aplicar
              </button>
            </div>
          </mat-menu>
        </div>

        <button
          mat-button
          disableRipple
          class="btn-clear-all"
          (click)="clearFilters()"
        >
          Limpar todos os filtros
        </button>
      </div>

      <div style="height: 4px">
        @if (isLoading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
      <!-- indicadores gerais de somatória da consulta, também chamado na especificação de "grandes números"-->
      <app-totalizer
        [cultura]="culturaSelecionada"
        [summary]="resultResponse()?.dashboard ?? null"
      ></app-totalizer>
    </div>

    <div class="totalizer-map">
      <app-results-map
        [idList]="resultResponse()?.idList ?? []"
        class="map-container"
      ></app-results-map>
    </div>
  </div>

  <div class="table-paginator">
    <!-- Legenda ZARC -->
    <div class="zarc-legend">
      <span class="zarc-legend__label">Legenda ZARC:</span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--20">20%</span>
        Menor Risco (20%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--30">30%</span>
        Risco Médio (30%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--40">40%</span>
        Maior Risco (40%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--no-zoning">Fora do Zoneamento</span>
      </span>
    </div>

    <app-table-monitoring-safra-results
      [data]="resultResponse()?.list ?? []"
      [loading]="isLoading()"
      [currentFilters]="getCurrentFilters()"
      [currentPage]="pageIndex"
      [currentPageSize]="pageSize"
      [currentSort]="currentSort"
      [cultures]="cultures"
      [targetCulture]="culturaSelecionada"
      (sortChange)="onSortChange($event)"
    ></app-table-monitoring-safra-results>
    <mat-paginator
      [length]="resultResponse()?.total ?? 0"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      aria-label="Paginação de resultados"
      (page)="onPageChange($event)"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</section>
